

































import { Vue, Component } from 'vue-property-decorator'
import {firebaseApp} from "@/plugins/firebase";
import {mapState} from "vuex";

@Component({
  computed: mapState("auth", ["user"])
})
export default class ProfileMenu extends Vue {

  user: any

  signOut () {
    this.$store.dispatch('reset')
    firebaseApp.auth().signOut();
    this.$router.push('/')
  }

}
